export function KeyobardOpenIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M16.5 17.96a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1zM13 17.46a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1zM8.5 17.96a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1zM17 14.46a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1zM12.5 14.96a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1zM9 14.46a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1z"
      ></path>
      <path
        fill="currentColor"
        d="M22 18.96a3 3 0 01-3 3H5a3 3 0 01-3-3v-7a3 3 0 013-3h14a3 3 0 013 3v7zm-3 1a1 1 0 001-1v-7a1 1 0 00-1-1H5a1 1 0 00-1 1v7a1 1 0 001 1h14zM14.445 6.792a1 1 0 001.11-1.664l-2.89-1.926a1.2 1.2 0 00-1.33 0l-2.89 1.926a1 1 0 001.11 1.664L12 5.162l2.445 1.63z"
      ></path>
    </svg>
  );
}
